/* =============================================================
   KYARNA Motion Engine v2.0
   Pure vanilla JS — no dependencies, no libraries.
   Scroll reveals + microcopy + shipping text correction.
   ============================================================= */
(function() {
  'use strict';

  // ─── GUARD: skip if reduced motion preferred ───
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ─── SCROLL REVEAL — IntersectionObserver ───
  function initScrollReveal() {
    if (prefersReduced) return;
    if (!('IntersectionObserver' in window)) return;

    var opts = {
      root: null,
      rootMargin: '0px 0px -60px 0px',
      threshold: 0.08
    };

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('kbh-in', 'ky-in');
          observer.unobserve(entry.target);
        }
      });
    }, opts);

    document.querySelectorAll(
      '.kbh-scroll-reveal, .kbh-scroll-stagger, .ky-reveal, .ky-reveal-stagger, .ky-trust-item, .ky-section-heading'
    ).forEach(function(el) {
      observer.observe(el);
    });
  }

  // ─── AUTO-TAG SCROLL TARGETS ───
  function autoTagSections() {
    if (prefersReduced) return;

    // Product grids outside hero
    var productGrids = document.querySelectorAll('.product-grid, .collection-product-grid, .grid.grid--4-col-desktop');
    productGrids.forEach(function(grid) {
      if (!grid.closest('.hero') && !grid.closest('#kyarna-black-homepage')) {
        grid.classList.add('ky-reveal-stagger');
      }
    });

    // Section headings outside kbh
    var headings = document.querySelectorAll('main h2, main h3');
    headings.forEach(function(h) {
      if (!h.closest('#kyarna-black-homepage')) {
        h.classList.add('ky-reveal');
      }
    });
  }

  // ─── SHIPPING TEXT CORRECTOR ───
  // Replaces any outdated "24h" shipping language sitewide
  function fixShippingText() {
    var corrections = [
      { old: 'Ships Within 24 Hours', next: 'Delivery within 1–3 days' },
      { old: 'Ships in 24 Hours',     next: 'Delivery within 1–3 days' },
      { old: 'Shipped in 24h',        next: 'Delivery within 1–3 days' },
      { old: 'within 24 hours',       next: 'within 1–3 business days' },
      { old: 'Ships within 24 hours', next: 'Delivery within 1–3 days' }
    ];

    // Walk all text nodes in the document and replace
    function walkAndReplace(node) {
      if (node.nodeType === Node.TEXT_NODE) {
        var val = node.nodeValue;
        corrections.forEach(function(c) {
          if (val.indexOf(c.old) !== -1) {
            node.nodeValue = val.split(c.old).join(c.next);
            val = node.nodeValue;
          }
        });
      } else if (node.nodeType === Node.ELEMENT_NODE && node.childNodes.length) {
        node.childNodes.forEach(walkAndReplace);
      }
    }

    walkAndReplace(document.body);
  }

  // ─── PRODUCT PAGE MICROCOPY ───
  function injectProductMicrocopy() {
    var productTitle = document.querySelector('.product__title h1, .product-single__title, .product__info-container h1');
    if (productTitle && !document.querySelector('.ky-product-microcopy')) {
      var strip = document.createElement('ul');
      strip.className = 'ky-product-microcopy';
      strip.setAttribute('aria-label', 'Product guarantees');
      strip.innerHTML = [
        '<li>Crafted for your device</li>',
        '<li>6-month warranty included</li>',
        '<li>Delivery within 1–3 days</li>',
        '<li>Nationwide delivery across Egypt</li>'
      ].join('');
      productTitle.after(strip);
    }
  }

  // ─── PAGE TRANSITION ───
  function initPageTransition() {
    if (prefersReduced) return;
    var main = document.getElementById('MainContent');
    if (main && !main.classList.contains('ky-page-enter')) {
      main.classList.add('ky-page-enter');
    }
  }

  // ─── INIT ───
  function init() {
    initPageTransition();
    autoTagSections();
    fixShippingText();
    injectProductMicrocopy();
    initScrollReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
